import React, { Component, Suspense } from 'react';
import { Card, Form, Button, Badge } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

class CodingEventImportResults extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            result: {
                model: {
                    codingEvents: [],
                    importExceptions: []
                }
            }};
    }

    componentDidMount() {
        //this.getCustomer();
        var result = this.props.location.data;
        if (result != undefined) {
            this.setState({ result: result })
        } else {
            this.props.history.push({
                pathname: '/codingevents/import',
                data: result // your data array of objects
            })
        }
    }

    renderImportEventsTable() {
        return (
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Visit Id</th>
                            <th>Account</th>
                            <th>Queue</th>
                            <th>Assigned To</th>
                            <th>Service Request</th>
                            <th>Case Origin</th>
                            <th>LOB</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.result.model.codingEvents.map((event) =>
                            <tr key={event.id}>
                                <td>{event.description}</td>
                                <td>{event.customerAccountName}</td>
                                <td>{event.codingEventQueueName}</td>
                                <td>{event.assignedToName}</td>
                                <td>{event.serviceRequest === 0 ? 'Unknown' : event.serviceRequest === 1 ? 'EOC' : 'SOC'}</td>
                                <td>{event.caseOrigin === 0 ? 'Unknown' : event.caseOrigin === 1 ? 'Manual Import' : 'Email'}</td>
                                <td>{event.lineOfBusiness === 0 ? 'Unknown' : event.lineOfBusiness === 1 ? 'Home Health' : 'Hospice'}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
        );
    }
    renderImportExceptionsTable() {
        return (            
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Exception Type</th>
                        <th>Visit Id</th>
                        <th>Account</th>
                        <th>Service Request</th>
                        <th>Case Origin</th>
                        <th>LOB</th>
                        {
                         //   <th className="table-fit"></th>
                        }
                    </tr>
                </thead>
                <tbody>
                {this.state.result.model.importExceptions.map((ex) =>
                            <tr key={ex.id}>
                                <td>{ex.exceptionType === 1 ? "Invalid Data" : "Duplicate Import"}</td>
                                <td>{ex.visitId === '' || ex.visitId === null ? <Badge variant="warning">Invalid</Badge> : ex.visitId}</td>
                                <td>{ex.accountName === '' || ex.accountName === null ? <Badge variant="warning">Invalid</Badge> : ex.accountName}</td>
                                <td>{ex.serviceRequest === null ? <Badge variant="warning">Invalid</Badge> : ex.serviceRequest === 0 ? 'Unknown' : ex.serviceRequest === 1 ? 'EOC' : 'SOC'}</td>
                                <td>{ex.caseOrigin === null ? <Badge variant="warning">Invalid</Badge> : ex.caseOrigin === 0 ? 'Unknown' : ex.caseOrigin === 1 ? 'Manual Import' : 'Email'}</td>
                                <td>{ex.lineOfBusiness === '' || ex.lineOfBusiness === null ? <Badge variant="warning">Invalid</Badge> : ex.lineofBusiness === 0 ? 'Unknown' : ex.lineOfBusiness == 1 ? 'Home Health' : 'Hospice'}</td>
                                {
                                    //<td className="table-fit">
                                    //    <LinkContainer to={'/codingevents/import/results'}>
                                    //        <Button variant='secondary' size='sm'>Delete</Button>
                                    //    </LinkContainer>&nbsp;
                                    //    <LinkContainer to={'/codingevents/import/results'}>
                                    //        <Button variant='success' size='sm'>Save</Button>
                                    //    </LinkContainer>
                                    //</td>
                                }
                            </tr>
                        )}
                    </tbody>
                </table>
        );
    }

                render() {
        return (
            <Card>

                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto">Batch Import Results</div>
                    <div className="card-btn-group">
                    </div>
                </Card.Header>
                <Card.Body className="card-body-table">
                    {
                        this.state.result.model != undefined && this.state.result.model != undefined && this.state.result.model.importExceptions.length > 0 ?
                            <>
                                <div className="sub-header">Import Exceptions</div>
                                {this.renderImportExceptionsTable()}
                            </> : null
                    }
                    {
                        this.state.result.model != undefined && this.state.result.model != undefined && this.state.result.model.codingEvents.length > 0 ?
                            <>
                                <div className="sub-header">Import Results</div>
                                {this.renderImportEventsTable()}
                            </> : null
                    }
                </Card.Body>
                </Card>
            
                );
                }
                }

                export default CodingEventImportResults;